import { PromotionItemDto, PromotionItemSource, PromotionItemType } from '../../api/sbapi/sbapi-api-model';

export type PromotionItemLink = Omit<PromotionItemDto, 'type'> & {
	type: PromotionItemType.LINK;
};

type PromotionItemSingle = Omit<PromotionItemDto, 'type'> & {
	type: PromotionItemType.SINGLE;
};

type PromotionItemCombo = Omit<PromotionItemDto, 'type'> & {
	type: PromotionItemType.COMBO;
};

type PromotionItemPreCanned = Omit<PromotionItemDto, 'source'> & {
	source: PromotionItemSource.PRECANNED;
};

export const isPromotionLink = (promotion: Pick<PromotionItemDto, 'type'>): promotion is PromotionItemLink =>
	promotion.type === PromotionItemType.LINK;

export const isPromotionSingle = (promotion: Pick<PromotionItemDto, 'type'>): promotion is PromotionItemSingle =>
	promotion.type === PromotionItemType.SINGLE;

export const isPromotionCombo = (promotion: Pick<PromotionItemDto, 'type'>): promotion is PromotionItemCombo =>
	promotion.type === PromotionItemType.COMBO;

export const isPromotionPreCanned = (
	promotion: Pick<PromotionItemDto, 'source'>
): promotion is PromotionItemPreCanned => promotion.source === PromotionItemSource.PRECANNED;
